
SiteGroupCreationController.$inject = ['$scope', '$mdDialog', '$translate', 'StrategiesFactory'];
export function SiteGroupCreationController($scope, $mdDialog, $translate, StrategiesFactory) {

  $scope.ok = ok;
  $scope.cancel = cancel;
  $scope.selectedSiteType = null;
  $scope.allSiteTypes = []
  StrategiesFactory.getAll().forEach(s => $scope.allSiteTypes.push({
    id: s.getType(), 
    label: $translate.instant('account_type/' + s.getTypeString())
  }));

  init();

  function ok() {
    $mdDialog.hide($scope.siteGroup);
  }

  function cancel() {
    $mdDialog.cancel();
  }

  function init() {
    $scope.user = {};
  }
}
